var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{'opacity-50': _vm.disabled}},[_c('input',_vm._b({attrs:{"type":"checkbox","disabled":_vm.disabled || _vm.loading},on:{"change":function($event){return _vm.$emit('change', $event)}}},'input',_vm.$attrs,false)),(_vm.loading)?_c('Loader',{attrs:{"size":"4"}}):_c('span',{staticClass:"slider round"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }